import type { UploadedAttachment } from '@mem-ai-hub/shared';
import { getAccessToken } from './api';

export interface UploadResult {
  attachments: UploadedAttachment[];
}

/**
 * Uploads files to the backend and returns attachment metadata with IDs.
 */
export async function uploadFiles(files: File[]): Promise<UploadResult> {
  const token = await getAccessToken();

  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file);
  }

  const response = await fetch('/api/attachments/upload', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(
      (body as { error?: string }).error ?? `Upload failed (HTTP ${response.status})`,
    );
  }

  const json = await response.json();
  return json.data as UploadResult;
}
